/* TODO: t() */
import React from 'react';
import { View, StyleSheet, ViewProps } from 'react-native';

type Props = Omit<ViewProps, 'children'> & {
  children: React.ReactNode;
};

function ButtonToolbar(props: Props) {
  let { style, ...otherProps } = props;
  return <View style={[styles.root, style]} {...otherProps} />;
}

let styles = StyleSheet.create({
  root: {
    flexDirection: 'row',
  },
});

export default ButtonToolbar;
